import laborScreening from '@/api/laborScreening'
// import person from '@/api/person'
import { laborScreening as LaborScreeningModel } from '@/api/models'
import { mergeUserContext } from '@/store/helpers'
import laborScreeningFields from './data/laborScreeningFields.json'

const state = {
    personLaborScreenings: [],
    laborScreening: Object.assign({}, LaborScreeningModel),
    laborScreeningFields: laborScreeningFields.items,
    createLaborScreeningError: false
}

const getters = {
    getLaborScreeningsByPerson: state => state.personLaborScreenings,
    getLaborScreening: state => state.laborScreening,
    getLaborScreeningFields: state => state.laborScreeningFields
}

const actions = {
    async getLaborScreeningsByPerson ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        payload = payload || {}
        const response = await laborScreening.getLaborScreeningsByPerson(payload)
        const screenings = response.body
        screenings.sort((a, b) => {
            return new Date(b.createdAt) - new Date(a.createdAt)
        })

        if (screenings) {
            commit('SET_PERSON_LABOR_SCREENINGS', screenings)
        }
    },

    async getLaborScreening ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        payload.id = payload.id
        const response = await laborScreening.getLaborScreeningsByPerson(payload)
        if (response.body) {
            commit('SET_LABOR_SCREENING', response.body[0])
        }
    },

    async createLaborScreening ({ commit, rootState }, payload) {
        payload = mergeUserContext(payload, rootState)
        const response = await laborScreening.createLaborScreening(payload)

        if (response.error) {
            // display error
            commit('SET_CREATE_LABOR_SCREENING_ERROR', true)
        } else {
            commit('SET_CREATE_LABOR_SCREENING_ERROR', false)
            commit('SET_LABOR_SCREENING', response.body)
        }
    },

    initCreateLaborScreening ({ commit }) {
        commit('SET_CREATE_LABOR_SCREENING_ERROR', false)
        commit('SET_LABOR_SCREENING', Object.assign({}, LaborScreeningModel))
    }
}

const mutations = {
    SET_PERSON_LABOR_SCREENINGS (state, payload) {
        state.personLaborScreenings = payload
    },

    SET_LABOR_SCREENING (state, payload) {
        state.laborScreening = payload
    },

    SET_CREATE_LABOR_SCREENING_ERROR (state, payload) {
        state.createLaborScreeningError = payload
    },

    UPDATE_TRANSFERRED_LABORSCREENING (state, payload) {
        state.laborScreening = payload
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/laborScreening.js